
export function isOnAlert(startDate, endDate, taskStatus, taskType) {
  if (taskStatus === 'DELETED') {
    return true;
  }
  const currentDate = new Date(Date.now());
  return ((currentDate >= startDate) && (currentDate <= endDate) &&
    (taskStatus && ["OPEN", "OPEN_48"].includes(taskStatus.toUpperCase())) &&
    (taskType && taskType.toUpperCase()==="APPOINTMENT"));
}
